// ----------------------------------------------------------------------

export default function Card(theme) {
  const isAmik = theme.isAmik;
  const brand = theme.palette.brand;
  // Amik cards: white, 1px hairline border, 16px radius, soft lift on hover.
  const amikCard = isAmik
    ? {
        boxShadow: 'none',
        border: `1px solid ${brand.line}`,
        transition: 'transform .16s ease, box-shadow .16s ease, border-color .16s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: brand.shadowCard,
          borderColor: brand.line2,
        },
      }
    : null;

  return {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.customShadows.z8,
          borderRadius: theme.shape.borderRadiusMd,
          position: 'relative',
          zIndex: 0,
          border: `1px solid ${theme.palette.grey[200]}`,
          ...(amikCard || {}),
        }
      }
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { 
          variant: 'h6',
          fontWeight: 600,
          color: theme.palette.text.primary
        },
        subheaderTypographyProps: { 
          variant: 'body2',
          color: theme.palette.text.secondary
        }
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0),
          borderBottom: `1px solid ${theme.palette.grey[100]}`,
          marginBottom: theme.spacing(2)
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
          '&:last-child': {
            paddingBottom: theme.spacing(3)
          }
        }
      }
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2, 3, 3),
          gap: theme.spacing(1)
        }
      }
    }
  };
}
